<div class="lgpd--cookie" [ngClass]="{'lgpd--cookie__opened': !autorizadoUsarCookie}">
  <p>Usamos <strong>cookies</strong> para personalizar anúncios e melhorar a sua experiência no site.
    Ao continuar navegando, você concorda com a nossa
    <a href="/institucional/paginas/politica-de-privacidade" target="_blank">Política de Privacidade</a>
  </p><button class="lgpd--cookie-accept" (click)="aceitarUsoCookie()">continuar e fechar</button>
</div>
